import Link from 'next/link'

import { KineticFeedLinks } from './KineticFeedLinks'
import { Container } from '../layout/container'

type KineticWorkshopFooterProps = {
  className?: string
}

export function KineticWorkshopFooter({ className }: KineticWorkshopFooterProps) {
  return (
    <footer className={`border-kinetic-outline-variant/30 border-t py-8 ${className ?? ''}`}>
      <Container width="large" size="custom">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <span className="font-headline text-base font-bold text-white">Cloud Shuttle</span>
            <p className="mt-1 text-sm text-kinetic-on-surface-variant">
              HQ: UOW Innovation Campus, North Wollongong NSW • Sydney base: Stone &amp; Chalk Tech Central, Haymarket
            </p>
            <p className="mt-0.5 text-xs font-mono text-kinetic-outline">ABN 94 638 159 136</p>
          </div>
          <div className="flex flex-wrap gap-6">
            <Link
              href="/about-us"
              className="text-sm text-kinetic-on-surface-variant transition-colors hover:text-white"
            >
              About
            </Link>
            <Link
              href="/workshops"
              className="text-sm text-kinetic-on-surface-variant transition-colors hover:text-white"
            >
              Workshops
            </Link>
            <Link
              href="/spotlights"
              className="text-sm text-kinetic-on-surface-variant transition-colors hover:text-white"
            >
              Events
            </Link>
            <Link
              href="/post"
              className="text-sm text-kinetic-on-surface-variant transition-colors hover:text-white"
            >
              Insights
            </Link>
            <Link
              href="/contact-us"
              className="text-sm text-kinetic-on-surface-variant transition-colors hover:text-white"
            >
              Contact
            </Link>
          </div>
        </div>
        <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between font-mono text-[10px] uppercase tracking-wider text-kinetic-outline">
          <p>© {new Date().getFullYear()} Cloud Shuttle. All rights reserved.</p>
          <KineticFeedLinks variant="workshop" />
        </div>
      </Container>
    </footer>
  )
}
